import type {
  RemovePersonSeatCommand,
  RemovePersonSeatResult,
} from "@/domain/model/AccountSeatOverview";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";

export class RemovePersonSeat {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    command: RemovePersonSeatCommand,
    signal?: AbortSignal,
  ): Promise<RemovePersonSeatResult> {
    return this.service.removePersonSeat(command, signal);
  }
}
